import { useContext, useEffect, useRef } from 'react'
import useFetch from './useFetch'
import { appStateContext } from '../App'
import stringify from 'fast-json-stable-stringify'
import usePagination from './usePagination'

export let syncStatus = {}

const useData = (props, optionalParams) => {
    const { state, setState } = useContext(appStateContext)
    // explicit reference to get current value
    const state_ref = useRef(state)

    let url, params, initialData, transform, conditions, page, paginate
    if (typeof props === 'string') {
        url = props
        conditions = optionalParams || {}
    } else if (props && typeof props === 'object') {
        ;({ url, params, transform, page, paginate } = props)
        conditions = optionalParams
    }
    const urlGroup = url
    if (paginate) {
        ;({ url, params } = paginate({ url, params, page }))
    }
    const key = 'fetched-' + url + ((params && stringify(params)) || '')

    let { data, isLoading, isError, isReady, refresh } = useFetch({ url, params, initialData, transform }, conditions)

    const _setState = value => {
        setState({
            ...state_ref.current,
            [key]: {
                ...state_ref.current[key],
                isLoading: false,
                data: value,
                setState: _setState
            }
        })
    }

    const on = () => {}

    const toc = usePagination(page, key, urlGroup)

    useEffect(() => {
        isReady = (typeof state[key] !== 'undefined' && typeof state[key].data !== 'undefined' && !!(data || state[key].data)) || isReady
        const _data = data || (state[key] && state[key].data)
        setState({
            ...state,
            [key]: {
                data: _data,
                isLoading,
                isError,
                isReady,
                refresh,
                setState: _setState,
                on,
                toc,
                paginated:
                    (page &&
                        [
                            ...Object.keys(toc)
                                .filter(k => toc[k].urlGroup === urlGroup)
                                .map(_page => {
                                    const c = toc[_page]
                                    const data_value = (key !== c.key && state[c.key] && state[c.key].data) || _data
                                    return (data_value && { data: data_value, page: _page }) || null
                                })
                        ].filter(Boolean)) ||
                    undefined
            }
        })
    }, [data, isLoading, isError, isReady])

    if (!url)
        return {
            isLoading: false,
            isReady: false,
            refresh,
            setState: _setState,
            on
        }
    return (
        (typeof state[key] === 'undefined' && {
            isLoading: false,
            isReady: false,
            refresh,
            setState: _setState,
            on,
            toc,
            paginated:
                (page &&
                    [
                        ...Object.keys(toc)
                            .filter(k => toc[k].urlGroup === urlGroup)
                            .map(_page => {
                                const c = toc[_page]
                                const data_value = state[c.key] && state[c.key].data
                                return (data_value && { data: data_value, page: _page }) || null
                            })
                    ].filter(Boolean)) ||
                undefined
        }) ||
        state[key]
    )
}

export default useData
